import { getResponseQuery } from "../../helpers/_functions";
import http from "../../http-common";
import BaseService from "../base.service";

class SurveyRespondent extends BaseService {
  constructor() {
    super("survey-respondents");
  }

  getBySurveyRequest(surveyRequestId) {
    return getResponseQuery(
      http.get(`${this.path}/get-by-survey-request/${surveyRequestId}`)
    );
  }

  deleteMany(reqbody) {
    return getResponseQuery(http.post(`${this.path}/delete-many`, reqbody));
  }
}

export default new SurveyRespondent();
